import React from 'react'
import ImageTextSection from '../components/auth/ImageTextSection'
import forgotPasswordIllustration2 from '../assets/forgotPasswordIllustration2.png'
import VerticalDivider from '../components/auth/VerticalDivider'
import OuterContainer from '../components/auth/OuterContainer'
import MiddleContainer from '../components/auth/MiddleContainer'
import InnerContainer from '../components/auth/InnerContainer'
import ForgotPasswordSection from '../components/auth/ForgotPasswordSection'

const ForgotPasswordScreen = () => {
  return (
    <OuterContainer>
      <MiddleContainer>
        <InnerContainer>
          <ImageTextSection imagePath={forgotPasswordIllustration2} />

          <VerticalDivider />

          <ForgotPasswordSection />
        </InnerContainer>
      </MiddleContainer>
    </OuterContainer>
  )
}

export default ForgotPasswordScreen
